import { Badge } from '@chakra-ui/react';
import { AbsenceStatus } from '../../types';
import { useIntl } from 'react-intl';

export const absenceStatusColorMap: Record<AbsenceStatus, string> = {
    [AbsenceStatus.PENDING]: 'yellow',
    [AbsenceStatus.APPROVED]: 'green',
    [AbsenceStatus.REJECTED]: 'red',
    [AbsenceStatus.CANCELLED]: 'gray',
};

type AbsenceStatusBadgeProps = {
    status: AbsenceStatus;
};

export const AbsenceStatusBadge: React.FC<AbsenceStatusBadgeProps> = ({ status }) => {
    const intl = useIntl();

    return (
        <Badge colorScheme={absenceStatusColorMap[status]} borderRadius="md">
            {intl.formatMessage({ id: `absence.status.${status}` })}
        </Badge>
    );
};
